"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireDefault(require("react"));

var _this = void 0,
    _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/ui/header.tsx";

var Header = function Header(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      icon = _ref.icon,
      meta = _ref.meta;
  return /*#__PURE__*/_react["default"].createElement(HeaderWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 3,
      columnNumber: 62
    }
  }, /*#__PURE__*/_react["default"].createElement(IconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4,
      columnNumber: 3
    }
  }, icon), /*#__PURE__*/_react["default"].createElement(TitleWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 4
    }
  }, title), subtitle && /*#__PURE__*/_react["default"].createElement(SubTitle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 17
    }
  }, subtitle)), meta && /*#__PURE__*/_react["default"].createElement(MetaWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 13
    }
  }, meta.map(function (_ref2, index) {
    var name = _ref2.name,
        value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 44
      }
    }, /*#__PURE__*/_react["default"].createElement(MetaName, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 7
      }
    }, name), /*#__PURE__*/_react["default"].createElement(MetaValue, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 7
      }
    }, value));
  })));
};

exports.Header = Header;

var HeaderWrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      C = _ref3$as === void 0 ? "div" : _ref3$as,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 92
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1nzjrz8",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 96
    }
  }, [".cc-1nzjrz8{display:flex;align-items:center;background-color:rgba(0,0,0,.3)}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1nzjrz8" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 202
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  HeaderWrapper.displayName = "HeaderWrapper";
}

var IconWrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var _ref4$as = _ref4.as,
      C = _ref4$as === void 0 ? "div" : _ref4$as,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 90
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "156d9zg",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 94
    }
  }, [".cc-156d9zg{display:flex;align-items:center;justify-content:center;flex:0 0 60px;height:60px;background-color:#111}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-156d9zg" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 239
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  IconWrapper.displayName = "IconWrapper";
}

var TitleWrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref5, ref) {
  var _ref5$as = _ref5.as,
      C = _ref5$as === void 0 ? "div" : _ref5$as,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 91
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1nohg8l",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 95
    }
  }, [".cc-1nohg8l{flex-grow:1;padding:0 15px;min-width:0;white-space:nowrap}", ".cc-1nohg8l > *{overflow:hidden;text-overflow:ellipsis}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1nohg8l" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 254
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  TitleWrapper.displayName = "TitleWrapper";
}

var Title = /*#__PURE__*/_react["default"].forwardRef(function (_ref6, ref) {
  var _ref6$as = _ref6.as,
      C = _ref6$as === void 0 ? "div" : _ref6$as,
      props = (0, _objectWithoutProperties2["default"])(_ref6, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 84
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1o6m25h",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 88
    }
  }, [".cc-1o6m25h{font-size:16px}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1o6m25h" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 145
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Title.displayName = "Title";
}

var SubTitle = /*#__PURE__*/_react["default"].forwardRef(function (_ref7, ref) {
  var _ref7$as = _ref7.as,
      C = _ref7$as === void 0 ? "div" : _ref7$as,
      props = (0, _objectWithoutProperties2["default"])(_ref7, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 87
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "25pedb",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 91
    }
  }, [".cc-25pedb{color:#ffc99a;font-size:12px}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-25pedb" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 160
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  SubTitle.displayName = "SubTitle";
}

var MetaWrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref8, ref) {
  var _ref8$as = _ref8.as,
      C = _ref8$as === void 0 ? "dl" : _ref8$as,
      props = (0, _objectWithoutProperties2["default"])(_ref8, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 89
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "12zq2aa",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 93
    }
  }, [".cc-12zq2aa{display:grid;grid-template-columns:auto auto;gap:0 6px;margin:0 15px 0 0;text-align:right}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-12zq2aa" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 225
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  MetaWrapper.displayName = "MetaWrapper";
}

var MetaName = /*#__PURE__*/_react["default"].forwardRef(function (_ref9, ref) {
  var _ref9$as = _ref9.as,
      C = _ref9$as === void 0 ? "dt" : _ref9$as,
      props = (0, _objectWithoutProperties2["default"])(_ref9, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 86
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "18485mb",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 90
    }
  }, [".cc-18485mb{color:#aaa}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-18485mb" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 143
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  MetaName.displayName = "MetaName";
}

var MetaValue = /*#__PURE__*/_react["default"].forwardRef(function (_ref10, ref) {
  var _ref10$as = _ref10.as,
      C = _ref10$as === void 0 ? "dd" : _ref10$as,
      props = (0, _objectWithoutProperties2["default"])(_ref10, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 87
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "mdn430",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 91
    }
  }, [".cc-mdn430{margin:0}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-mdn430" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 140
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  MetaValue.displayName = "MetaValue";
}